'use client';

import { useId } from 'react';

import { FilterSection } from './filter-section.component';
import { FilterOptionsSectionProps } from './filter-options-section.type';

import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group.component';
import { cn } from '@/utils/cn-tw-merge';

export function FilterRadioGroupSection<TValue extends string>({
  label,
  value,
  options,
  onChange,
  disabled = false,
  testId,
  getOptionTestId,
}: FilterOptionsSectionProps<TValue>) {
  const labelId = useId();

  return (
    <FilterSection label={label} labelId={labelId}>
      <RadioGroup
        value={value}
        onValueChange={(next) => onChange(next as TValue)}
        aria-labelledby={labelId}
        disabled={disabled}
        className="gap-4"
        data-testid={testId}
      >
        {options.map((option) => {
          const optionId = `${labelId}-${option.value}`;

          return (
            <div key={option.value} className="flex items-center gap-3">
              <RadioGroupItem
                id={optionId}
                value={option.value}
                circleSize="xl"
                className="shrink-0"
                data-testid={getOptionTestId?.(option.value)}
              />
              <label
                htmlFor={optionId}
                className={cn(
                  'cursor-pointer text-base leading-6 text-gray-900',
                  option.value === value && 'font-semibold',
                  disabled && 'cursor-not-allowed opacity-50',
                )}
              >
                {option.label}
              </label>
            </div>
          );
        })}
      </RadioGroup>
    </FilterSection>
  );
}
